import { MenuItem, ListItemButton, Button, Box } from '@mui/material';
import { TextFieldSelect } from 'shell/OnlineBookingTheme/components';
import { styled } from '@mui/system';
import { ListItemText } from '@mui/material';

const QuestionFormRoot = styled('div', {target: 'QuestionFormRoot'} )(({ theme}) => ({
    margin: theme.spacing(2,0,2,0),
}))

const StyledListItemButton = styled(ListItemButton, {target: 'StyledListItemButton'})(({ theme }) => ({
    boxShadow: `0px 1px 4px rgb(${theme.vars.palette.primary.mainChannel} / 0.16)`,
    border: `1px solid transparent`,
    borderRadius: theme.spacing(1),
    textAlign: 'center !important',
    flex: '1',
    '&:hover,:focus': {
        backgroundColor: 'transparent',
    },
    '&.selected': {
        backgroundColor: theme.vars.palette.secondary.main,
    },
    '&:hover,&:focus,&.selected': {
        border: `1px solid ${theme.vars.palette.primary.main}`,
        boxShadow: `0px 1px 8px rgb(${theme.vars.palette.primary.mainChannel} / 0.25)`,
    },
    '& .MuiTypography-root': {
        color: theme.vars.palette.primary.main,
    },
    '& .MuiListItemText-primary': {
        fontWeight: 500,
        fontSize: '0.875rem'
    },
    '& .MuiListItemText-secondary': {
        fontSize: '0.75rem'
    }
    
}))

const StyledListItemText = styled(ListItemText)(({theme}) =>({
    // overflow: 'hidden', 
    // display: '-webkit-box', 
    // WebkitBoxOrient: 'vertical', 
    // WebkitLineClamp: 4,
    '& .MuiListItemText-primary': {
        marginBottom: theme.spacing(1)
    }
}))

const Select = styled(TextFieldSelect)(({theme}) => ({
  }));

const StyledMenuItem = styled(MenuItem)(({theme}) => ({
    '& .MuiListItemText-root ': {
        minHeight: '40px',
        whiteSpace: 'break-spaces',
        '& .MuiTypography-body1':{
            fontSize: '14px'
        },
        '& .MuiTypography-body2':{
            fontSize: '12px'
        }
    }
}))

const StyledAnswerArea = styled('div')(({theme}) => ({
    margin: theme.spacing(1,0,2,0)
}))

const StyledSecondaryButton = styled(Button)(({ theme }) => ({
    fontSize: '12px',
  }))

  const ClearButtonWrapper = styled(Box)(({ theme }) => ({
    textAlign: 'end',
  }))

const StyledFormControlLabel = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    '& .muiltr-31lz24-MuiButtonBase-root-MuiCheckbox-root': {
        margin: theme.spacing(-1, 1, 1, -1),
    },
}));

const StyledIconTextWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    gap: theme.spacing(1),
    [`@media (max-width: ${theme.breakpoints.values.sm}px)`]: {
        flexDirection: 'column',
        textAlign: 'center',
    },
}));

const StyledIcon = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '2rem', 
    [`@media (max-width: ${theme.breakpoints.values.sm}px)`]: {
        marginBottom: theme.spacing(1),
    },
}));

const StyledText = styled('div')(({ theme }) => ({
    fontSize: '1rem',
    color: theme.vars.palette.text.primary,
    [`@media (max-width: ${theme.breakpoints.values.sm}px)`]: {
        marginTop: theme.spacing(0.5),
    },
}));


export {
    QuestionFormRoot,
    Select,
    StyledMenuItem,
    StyledAnswerArea,
    StyledListItemText,
    StyledListItemButton,
    StyledSecondaryButton,
    ClearButtonWrapper,
    StyledFormControlLabel,
    StyledIconTextWrapper,
    StyledIcon,
    StyledText
};

